export default __webpack_public_path__ + "static/media/logo.46cb33d9.jpg";